export default {
  name: 'MainTitle',
  template: `
<div class="main-title">
  <div class="container">
    <button
      v-if="showBackButton"
      class="main-title__back"
      @click="$router.push(backRoute)">
      <i class="icon-arrow-left-long"></i>
      <span>{{ backText }}</span>
    </button>

    <div class="main-title__text">
      <span v-if="number" class="main-title__number">{{ number }}</span>
      <h1 class="no-margin">{{ title }}</h1>
    </div>
  </div>
</div>
  `,
  props: {
    title: String,
    backRoute: {
      type: Object,
      required: false,
    },
    backText: {
      type: String,
      required: false,
    },
    number: {
      type: String,
      required: false,
    },
    showBackButton: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
}
